import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';

const MenuField = (props) => {
  const { onClick, record } = props;
  const handleClick = React.useCallback(
    (event) => {
      onClick(event, record);
    },
    [onClick, record],
  );

  return (
    <Button variant="text" color="primary" size="small" onClick={handleClick}>
      <MoreVertIcon />
    </Button>
  );
};

MenuField.propTypes = {
  onClick: PropTypes.func.isRequired,
  record: PropTypes.object,
};

MenuField.defaultProps = {
  record: {},
};

export default MenuField;
